import { EMPTY_STRING } from 'constants/appConstants';

export const getIdfromSubscriptionIdToNameMap = (
  subscriptionIdToNameMap,
  subscriptionName,
) => {
  return (
    Object.keys(subscriptionIdToNameMap).find(
      (id) => subscriptionIdToNameMap?.[id] === subscriptionName,
    ) || EMPTY_STRING
  );
};
